import React from "react";
import buttonYellowLeftLayer from "../../../assets/images/svg/button-yellow-left-layer.svg";
import buttonYellowRightLayer from "../../../assets/images/svg/button-yellow-right-layer.svg";

const Button = ({ title, className, onClick, type = "button", disabled }) => {
  return (
    <>
      <div
        className={`mt-3 mt-lg-4 position-relative w_fit_content m-auto m-lg-0 ${className}`}
      >
        <img
          className="position-absolute navbar_left_vector z_index_1 start-0"
          src={buttonYellowLeftLayer}
          alt="button-yellow-left-layer"
        />
        <img
          className="position-absolute navbar_right_vector z_index_1 end-0"
          src={buttonYellowRightLayer}
          alt="button-yellow-right-layer"
        />
        <button 
          className="common_btn" 
          onClick={onClick}
          type={type}
          disabled={disabled}
        >
          {title}
        </button>
      </div>
    </>
  );
};

export default Button;
